export default __webpack_public_path__ + "static/media/264.9b84a784.gif";